import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a92f1e66d471300141a48c8_1788261451098_c302c262/learnforex/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a92f1e66d471300141a48c8_1788261451098_c302c262/learnforex/src/styles/index.css");
